// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proud_main_div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 120px;
    background: rgba(210, 211, 212, 0.20);
    margin-top: 0px;
}

.proud_inner_div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 257px;
}







@media screen and (max-width: 1400px) {

    .proud_main_div {
        padding: 40px 80px;
        margin-top: 0px;
    }
    
    .proud_inner_div {
        justify-content: space-between;
        gap: 50px;
    }

}









@media screen and (max-width: 1200px) {

    .proud_main_div {
        padding: 20px 60px;
        margin-top: 0px;
    }
    
    .proud_inner_div {
        justify-content: space-between;
        gap: 50px;
    }

}






@media screen and (max-width: 1024px) {

    .proud_main_div {
        padding: 20px 40px;
        margin-top: 0px;
    }
    
    .proud_inner_div {
        justify-content: space-between;
        gap: 70px;
    }

    .proud_inner_div > img {
        width: 300px !important;
    }

    .proud_inner_div > p {
        font-size: 16px;
        line-height: 22px;
    }
}








@media screen and (max-width: 800px) {

    .proud_main_div {
        padding: 30px 40px 20px 40px;
        margin-top: 0px;
    }
    
    .proud_inner_div {
        justify-content: center;
        flex-direction: column;
        gap: 30px;
    }

    .proud_inner_div > img {
        width: 300px !important;
    }

    .proud_inner_div > p {
        font-size: 16px;
        line-height: 22px;
        text-align: center;
    }
}












@media screen and (max-width: 600px) {

    .proud_main_div {
        padding: 20px 20px 10px 20px;
        margin-top: 0px;
    }
    
    .proud_inner_div {
        gap: 20px;
    }

    .proud_inner_div > img {
        width: 300px !important;
    }

    .proud_inner_div > p {
        font-size: 16px;
        line-height: 22px;
    }
}










@media screen and (max-width: 450px) {

    .proud_main_div {
        padding: 20px 16px 10px 16px;
    }
    
    .proud_inner_div {
        gap: 20px;
    }

    .proud_inner_div > img {
        width: 300px !important;
    }

    .proud_inner_div > p {
        font-size: 16px;
        line-height: 22px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/homepage/proud/proud.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;AACd;;;;;;;;AAQA;;IAEI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;AAEJ;;;;;;;;;;AAUA;;IAEI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;AAEJ;;;;;;;AAOA;;IAEI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;;;;;;;AASA;;IAEI;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;;;;;;;;;;;;AAaA;;IAEI;QACI,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;;;;;;;;;AAWA;;IAEI;QACI,4BAA4B;IAChC;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".proud_main_div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 120px;\n    background: rgba(210, 211, 212, 0.20);\n    margin-top: 0px;\n}\n\n.proud_inner_div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 257px;\n}\n\n\n\n\n\n\n\n@media screen and (max-width: 1400px) {\n\n    .proud_main_div {\n        padding: 40px 80px;\n        margin-top: 0px;\n    }\n    \n    .proud_inner_div {\n        justify-content: space-between;\n        gap: 50px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n\n    .proud_main_div {\n        padding: 20px 60px;\n        margin-top: 0px;\n    }\n    \n    .proud_inner_div {\n        justify-content: space-between;\n        gap: 50px;\n    }\n\n}\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n    .proud_main_div {\n        padding: 20px 40px;\n        margin-top: 0px;\n    }\n    \n    .proud_inner_div {\n        justify-content: space-between;\n        gap: 70px;\n    }\n\n    .proud_inner_div > img {\n        width: 300px !important;\n    }\n\n    .proud_inner_div > p {\n        font-size: 16px;\n        line-height: 22px;\n    }\n}\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n    .proud_main_div {\n        padding: 30px 40px 20px 40px;\n        margin-top: 0px;\n    }\n    \n    .proud_inner_div {\n        justify-content: center;\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .proud_inner_div > img {\n        width: 300px !important;\n    }\n\n    .proud_inner_div > p {\n        font-size: 16px;\n        line-height: 22px;\n        text-align: center;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n    .proud_main_div {\n        padding: 20px 20px 10px 20px;\n        margin-top: 0px;\n    }\n    \n    .proud_inner_div {\n        gap: 20px;\n    }\n\n    .proud_inner_div > img {\n        width: 300px !important;\n    }\n\n    .proud_inner_div > p {\n        font-size: 16px;\n        line-height: 22px;\n    }\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n    .proud_main_div {\n        padding: 20px 16px 10px 16px;\n    }\n    \n    .proud_inner_div {\n        gap: 20px;\n    }\n\n    .proud_inner_div > img {\n        width: 300px !important;\n    }\n\n    .proud_inner_div > p {\n        font-size: 16px;\n        line-height: 22px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
